import { ISection } from 'gcf-player/shared-utils';
import { lang } from 'src/utils';

import { StyledSectionPill, StyledTooltip } from './SectionPill.styled';

export const SectionPill = ({
  section,
  tooltip,
  zoom,
}: {
  section: ISection;
  tooltip?: string;
  zoom?: number;
}) => {
  const isScheduled = section?.isScheduleItem;
  const tooltipText = tooltip ?? (isScheduled ? lang.scheduled : lang.default);

  return (
    <StyledTooltip title={tooltipText} arrow placement="top">
      <StyledSectionPill
        $isScheduled={isScheduled}
        $zoom={zoom}
        data-testid="section-pill"
      />
    </StyledTooltip>
  );
};
